/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var isEventManagementForm = function (form) {
    var _a;
    return (_a = form.FormApiBaseUrl) === null || _a === void 0 ? void 0 : _a.endsWith("/eventmanagement");
};
